import * as React from 'react';

import { Label } from 'office-ui-fabric-react/lib/Label';
import { TextField} from 'office-ui-fabric-react/lib/TextField';
import { ChoiceGroup} from 'office-ui-fabric-react/lib/ChoiceGroup';
import { PrimaryButton , DefaultButton } from 'office-ui-fabric-react/lib/Button';

import { Utils } from './classi/Utils.js';
import { Session } from './classi/Session.js';

import './css/BloccaGdpr.css';

const utils = new Utils();
const session = new Session();

export class BloccoGdprInfo extends React.Component {
    
    constructor() {
        super()
        
        let du = session.get('datiutente');
        
        let GDPRobbligo = utils.getObjInfoSocieta( 'GDPR_OBBLIGO_COMPILA' , '' );
        let GDPRvedi = utils.getObjInfoSocieta( 'VISUALIZZA_FLG_GDPR' , '' );
        let GDPRaccept = utils.getObjInfoSocieta( 'GDPR_VALORI_ACCETTATI' , '' );
        
        let erroreInfoprivacy = '';
        if( GDPRobbligo==='SI' && GDPRvedi==='SI' &&  
              ( ( parseInt(du.FLG_GDPR_INFOPRIVACY,10)===0 && ( typeof GDPRaccept[3] !== 'undefined' ) && GDPRaccept[3].indexOf('NO')===-1 ) || 
                ( parseInt(du.FLG_GDPR_INFOPRIVACY,10)===1 && ( typeof GDPRaccept[3] !== 'undefined' ) && GDPRaccept[3].indexOf('SI')===-1 ) )
        ){
            erroreInfoprivacy = ' erroreGDPR';
        }
        
        
        this.state = {
            ragsoc:du.RAGIONE_SOCIALE,
            FLG_GDPR_INFOPRIVACY : parseInt(du.FLG_GDPR_INFOPRIVACY,10)===1 ? '1' : (parseInt(du.FLG_GDPR_INFOPRIVACY,10)===0 ? '0' : '' ) ,
            txtpopup1 : '<br/>'+utils.getObjInfoSocieta( 'TESTO_POPUP_1' , '' ),
            txtpopup2 : '<br/>'+utils.getObjInfoSocieta( 'TESTO_POPUP_2' , '' ),
            testo:'',
            erroreInfoprivacy:erroreInfoprivacy
        };
        
        this._onChangeOption = this._onChangeOption.bind(this);
    }

    
    logOut = () => {
        utils.dialogLogout();
    }
    
    inviaForm = () => {
        
        let msgErr = '';
        
        let obblig = utils.getObjInfoSocieta( 'GDPR_VALORI_ACCETTATI' , '' );
        let FLGinfo =  document.getElementById( 'FLG_GDPR_INFOPRIVACY' ).value;
        
        console.log( 'FLGinfo' , FLGinfo);
        
        
        if( FLGinfo === '' ){
            msgErr+= 'Per accedere è obbligatorio compilare tutte le opzioni<br/>';
        }
        
        if( FLGinfo === '0' && typeof obblig[3] !== 'undefined' && obblig[3].indexOf('NO') === -1 ){
            msgErr+= 'INFORMATIVA PRIVACY : accettato solo valore '+obblig[3].replace('#',' o ')+'<br/>';
        }
        if( FLGinfo === '1' && typeof obblig[3] !== 'undefined' && obblig[3].indexOf('SI') === -1 ){
            msgErr+= 'INFORMATIVA PRIVACY : accettato solo valore '+obblig[3].replace('#',' o ')+'<br/>';
        }


        if( msgErr !== ''){ this.setState({testo:msgErr}); }
        else {
            // eseguo salvataggio Privacy
            let obj = {};
        
            // per tutti passo id_cliente
            obj['id_cliente'] = session.get('id_cliente');
            obj['tipo_operazione'] = 'privacy';
            
            obj['FLG_GDPR_INFOPRIVACY'] = FLGinfo;
            
            utils.inviaPrivacy( obj );
            this.gestisciRisultatoPrivacy( 0 );
        }
    }
    
    gestisciRisultatoPrivacy( count )
    {  
        count++;
        setTimeout( function(){

            var result = utils.leggiRisultatoPrivacy();
            if( count > 50)
            {
                this.setState( {testo: 'Timeout della Richiesta' } );
            }
            else if( result === false )
            {
                this.gestisciRisultatoPrivacy(count);
            }
            else
            {
                if( result.success === true ){ 
                    window.location.reload();
                }
                else {
                    if( 'message' in result && result.message !== ""){ 
                        let msg = result.message;
                        msg=msg.replace(/\n/g, "<br />");
                        this.setState( {testo: msg} );
                    }
                    else { this.setState( {testo: 'Errore Invio Informativa Privacy' } ); }
                }
            }
        }.bind(this),500 );
    } 
    
    
    _onChangeOption( event ,option ){
        if( option.id === 'FLG_GDPR_INFOPRIVACY'){ this.setState({FLG_GDPR_INFOPRIVACY : option.key }); }
    }
    
    render(){
        return (
            <div id="main-container">
                <div id="ac-container" className="bloccoGDPR">
                    <Label className='ms-fontSize-xxl titolo-pagina'>Informativa Privacy</Label>
                    
                    <Label className='ms-fontSize-m ms-fontWeight-semibold'><u>{this.state.ragsoc}</u></Label>
                    
                    <div className='ms-fontSize-s titolo-pagina' dangerouslySetInnerHTML={{__html: this.state.txtpopup1}}></div>
                    
                    <div className='ms-fontSize-s messaggio' dangerouslySetInnerHTML={{__html: this.state.testo}}></div>
                    
                    <div className='editprivacy'>
                        <ChoiceGroup
                            className={'defaultChoiceGroup' + this.state.erroreInfoprivacy }
                            defaultSelectedKey={ parseInt(this.state.FLG_GDPR_INFOPRIVACY,10)===1 ? '1' : (parseInt(this.state.FLG_GDPR_INFOPRIVACY,10)===0 ? '0' : '' )}
                            options={[ { key: '1', text: 'Si', id:'FLG_GDPR_INFOPRIVACY' }, { key: '0', text: 'No', id:'FLG_GDPR_INFOPRIVACY' } ]}
                            onChange={this._onChangeOption}
                            label={utils.getObjInfoSocieta( 'GDPR_INFOPRIVACY_DESC' , '' )}
                            required={false}
                        />

                        <TextField  value={ this.state.FLG_GDPR_INFOPRIVACY }  id='FLG_GDPR_INFOPRIVACY' className='nascosto' />

                        <div className='bottoni'>
                            <DefaultButton onClick={this.logOut} text="ESCI" />
                            <PrimaryButton onClick={this.inviaForm} text="Salva e Continua" />
                        </div>

                    </div>
                </div>
                <div id="dialogcontainer"></div>
            </div>
            
        );
    }
}

export default BloccoGdprInfo;


// WEBPACK FOOTER //
// ./src/AcComponents/BloccoGdprInfo.js